<template>
  <div class="padding">
    <!-- filter header -->
    <div class="row m-t-sm">
      <div class="col-md-3">
        <h5 class="_300 margin m-b-md">Archive Products</h5>
      </div>

      <div class="col-md-9">
        <div class="row">
          <div class="col-md-offset-3 col-md-3 p-b-sm">
            <select
              v-model="category"
              class="form-control c-select">
              <option :value="null">Select Category</option>
              <option
                v-for="category in categories"
                :value="category.id"
                :key="category.id">
                {{ category.name }}
              </option>
            </select>
          </div>

          <div class="col-md-3 p-b-sm">
            <select
              v-model="tagSelected"
              class="form-control c-select">
              <option value="0">Select Tags</option>
              <option
                v-for="tag in tagList"
                :value="tag.id"
                :key="tag.id">
                {{ tag.name }}
              </option>
            </select>
          </div>

          <div class="col-md-3 p-b-sm">
            <outlet-selector :outlet="$store.state.report.activeOutlet"/>
          </div>
        </div>
      </div>
    </div>

    <div class="box">
      <div class="p-a white lt box-shadow">
        <p class="m-b-0 inline">
          <a :href="indexUrl">Product</a>
        </p>
        <a
          :disabled="onLoading('save-product')"
          :href="indexUrl"
          class="nav-link pull-right"
        >
          <i class="material-icons">keyboard_arrow_left</i>
          <span>Product List</span>
        </a>
      </div>
      <v-server-table
        ref="datatable"
        :url="api"
        :name="tableName"
        :columns="columns"
        :options="options">

        <template
          slot="code"
          slot-scope="props">
          <optional-cell-value
            v-model="props.row.code"/>
        </template>

        <template
          slot="category"
          slot-scope="props">
          <optional-cell-value
            v-model="props.row.category"
            empty-text="No category assigned"/>
        </template>

      </v-server-table>

    </div>

    <div>
      <div v-if="inventoryFnb">
        <vuetableitem-form-fnb
          ref="itemFormFnb"
          @product-saved="refresh"/>
      </div>

      <div v-else>
        <vuetableitem_form
          ref="itemForm"
          @product-saved="refresh"/>
      </div>
    </div>

    <import-item/>

    <item-bulk-modal
      ref="itemBulkModal" />
  </div>

</template>

<script>
import { Event } from '../../../event-bus';
import Auth from '@js/plugins/auth';
import Feature from '@js/plugins/feature';
import importItem from './import-item.vue';
import ItemBulkModal from './item-bulk-modal';
import { mapGetters, mapActions } from 'vuex';
import OptionalCellValue from '@js/components/optional-cell-value';
import vuetableitemFormFnb from './vuetableitem_form_fnb';
import productModule from '@js/store/modules/product';

const TableName = 'VUETABLE_ITEM_ARCHIVE';

export default {
    components: {
        vuetableitemFormFnb,
        importItem,
        ItemBulkModal,
        OptionalCellValue,
    },

    data: function() {
        var that = this;
        let canManageItems = Auth.hasPermissionTo('franchise_manage_items');
        let viewOnlyItems = Auth.hasPermissionTo('admin_view_only_system');

        let actionButtons = [
            {
                title: 'Create Product',
                action: () => {
                    this.show_popup(null);
                },
            },
            {
                title: 'Import',
                action: () => {
                    this.showImportForm();
                },
            },
        ];

        if (!canManageItems) {
            actionButtons = [];
        }

        if (viewOnlyItems) {
            actionButtons = [];
        }

        return {
            product: {},
            tableName: TableName,
            tagSelected: 0,
            category: null,
            api: Laroute.route('franchise.inventory.item.archive'),
            inventoryFnb: Feature.hasFeature('inventory_fnb'),
            columns: [
                'code',
                'name',
                'outlet',
                'category',
                'tags',
                'price_type',
                'cost',
                'price',
            ],
            options: {
                preserveState: true,
                columnsDropdown: true,
                checkbox: canManageItems && !viewOnlyItems,
                checkboxActions: [
                    {
                        title: 'Restore Products',
                        callback: () => {
                            this.submitBulkRestore();
                        },
                    },
                ],
                customFilters: ['outlet_id', 'tag_id', 'category_id'],
                initFilters: { outlet_id: that.$store.getters.activeOutlet },
                orderBy: { column: 'name', ascending: 1 },
                headings: {
                    price_type: 'Price Mode',
                },
                templates: {
                    tags(h, row) {
                        return require('./vuetableitem_tags.jsx')(h, row);
                    },
                    outlet(h, row) {
                        return require('./vuetableitem_outlet.jsx')(h, row);
                    },
                    price_type(h, row) {
                        if (row.price_type == 0) {
                            return 'Variants';
                        }

                        if (row.price_type == 1) {
                            return 'Unit';
                        }

                        if (row.price_type == 2) {
                            return 'Variable';
                        }
                    },
                },
                csv_url: Laroute.route(
                    'franchise.inventory.item.exportAsFile',
                    { type: 'CSV' },
                ),
                pdf_url: Laroute.route(
                    'franchise.inventory.item.exportAsFile',
                    { type: 'PDF' },
                ),
                xls_url: Laroute.route(
                    'franchise.inventory.item.exportAsFile',
                    { type: 'XLSX' },
                ),
                // actionButtons: actionButtons,
                //
                // rowClassCallback: row => {
                //     let clazz = ['pointer'];
                //
                //     if (row.status == 0) {
                //         clazz.push('text-muted');
                //     }
                //
                //     return clazz;
                // },

                importCallback: that.showImportForm,
            },
        };
    },

    computed: {
        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },

        searchQuery() {
            return this.$refs.datatable.query;
        },

        ...mapGetters('pricebook', ['pricebook']),
        ...mapGetters('category', ['categories']),

        ...mapGetters('tag', ['tagList']),

        indexUrl() {
            return Laroute.route('franchise.inventory.item.index');
        },
    },

    watch: {
        activeOutlet: function() {
            this.$store.commit(`${TableName}/SET_CUSTOM_FILTER`, {
                filter: 'outlet_id',
                value: this.activeOutlet,
            });
        },

        tagSelected() {
            this.$store.commit(`${TableName}/SET_CUSTOM_FILTER`, {
                filter: 'tag_id',
                value: this.tagSelected,
            });
        },

        category() {
            this.$store.commit(`${TableName}/SET_CUSTOM_FILTER`, {
                filter: 'category_id',
                value: this.category,
            });
        },
    },

    created() {
        this.fetchAllTags();
    },

    mounted() {
        Event.$on('import-completed', () => {
            this.refresh();
            this.fetchAllTags();
        });

        Event.$on('import-error', () => {
            this.refresh();
            this.fetchAllTags();
        });

        Event.$on('bulk-product-updated', () => {
            this.$refs.datatable.clearCheckboxSelected();
            this.refresh();
        });
    },

    methods: {
        ...mapActions('tag', ['getTagList']),
        ...mapActions('product', ['bulkRestoreProduct']),

        fetchAllTags() {
            this.getTagList({
                limit: null,
                maxprice: null,
                modifiers: 1,
            });
        },

        show_popup(row) {
            if (!this.inventoryFnb) {
                this.$refs.itemForm.$emit('show-form', row);
            } else {
                this.$refs.itemFormFnb.$emit('show-form', row);
            }
        },

        refresh() {
            this.$refs.datatable.getData();
        },

        showImportForm() {
            $('#import-item').modal('show');
        },
        showProduct() {
            window.location.href = Laroute.route(
                'franchise.inventory.item.archive',
            );
        },

        bulkData() {
            let payload = {
                ids: this.$store.getters[
                    'VUETABLE_ITEM_ARCHIVE_CHECKBOX/getSelected'
                ],
            };
            payload.status = 1;
            return payload;
        },

        submitBulkRestore() {
            const payload = this.bulkData();

            this.swalAjaxConfirmation({
                title:
                    'Are you sure you want to restore the selected products?',
                text:
                    'This action will restore all selected archived products.',
                confirmText: 'Yes, restore!',
                type: 'warning',
                preConfirm: () => this.bulkRestoreProduct(payload),
                onSuccess: () => {
                    this.$refs.datatable.getData();
                    this.$refs.datatable.clearCheckboxSelected();
                    this.refresh();
                    this.showToastrSuccess(
                        'Products have been successfully restored.',
                    );
                },
                onError: () => {
                    this.showToastrError('Failed to restore products.');
                },
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/item/vuetable_archive.vue